/**
 * Utility functions for JSON operations
 */

/**
 * Safely parse a JSON string
 * @param str - The string to parse as JSON
 * @param options - Options for handling parse errors
 * @returns The parsed JSON object, or the original string on error (if returnStringOnError is true), or empty object
 */
export const safelyParseJSON = (
  str: string,
  options?: {
    returnStringOnError?: boolean; // return original string when failed JSON.parse
  }
) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    if (!!options?.returnStringOnError) {
      return str;
    }
    return {};
  }
};
